import React from "react";
import CardTitle from "./CardTitle";
import LabeledValue from "./LabeledValue";
import Pill from "./Pill";
import { CARD_SURFACE } from "./constants";

const VehicleCard = ({ vehicle, svg }) => {
  const isActive = vehicle?.status === "Active";

  return (
    <div className="bg-white flex flex-col overflow-hidden" style={{ ...CARD_SURFACE, padding: 20 }}>
      <div className="flex justify-between items-center flex-shrink-0" style={{ marginBottom: 12 }}>
        <CardTitle>Vehicle Assignment</CardTitle>
        {vehicle && (
          <Pill
            bg={isActive ? "#F2FFF7" : "#EEEDF0"}
            text={isActive ? "#00A440" : "#807E83"}
            border={isActive ? "#C2EED3" : "#D1CFD4"}
            style={{ fontSize: 16, padding: "3px 20px" }}>
            {vehicle.status || "Unknown"}
          </Pill>
        )}
      </div>

      {vehicle ? (
        <div className="flex items-center justify-between flex-1" style={{ gap: 16 }}>
          <div className="flex flex-col flex-1" style={{ gap: 12, minWidth: 0 }}>
            <LabeledValue label="Car Model" value={[vehicle.make, vehicle.model].filter(Boolean).join(" ")} />
            <LabeledValue label="Number Plate" value={vehicle.plate} />
            <LabeledValue label="Car Type" value={vehicle.type} />
          </div>
          <div className="flex items-center justify-center flex-shrink-0">
            {svg ? (
              // Inline SVG reused from the grouped-trip view helper (per vehicle
              // type + colour), rendered server-side and injected verbatim (w-40
              // ~ 160px). Fields take the remaining width, so they never overlap.
              <span style={{ display: "block" }} dangerouslySetInnerHTML={{ __html: svg }} />
            ) : (
              <span style={{ fontSize: 40 }}>🚗</span>
            )}
          </div>
        </div>
      ) : (
        <div className="text-gray-500 italic text-center flex-1 flex items-center justify-center" style={{ fontSize: 14 }}>
          No vehicle assigned.
        </div>
      )}
    </div>
  );
};

export default VehicleCard;
